<template>
  <div class="qr-code-box" v-if="valueBackup" @click="hideQrcode">
    <v-img :value="valueBackup" class="qr-code"/>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    valueBackup: '',
  }),
  watch: {
    value(value) {
      if (value !== this.valueBackup) this.valueBackup = value;
    },
    valueBackup(valueBackup) {
      if (valueBackup !== this.value) this.$emit('input', valueBackup);
    },
  },
  methods: {
    hideQrcode() {
      this.valueBackup = '';
    }
  },
  beforeMount() {
    this.valueBackup = this.value || '';
  },
};
</script>

<style scoped>
.qr-code-box {
  position: fixed;
  z-index: 9999;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #000000;
}

.qr-code {
  width: 100vw;
  height: 100vw;
}
</style>
